import { createAction, handleActions } from 'redux-actions'

const SET_BASE_TITLE = createAction('page/SET_BASE_TITLE')
const SET_PAGE_NAME = createAction('page/SET_PAGE_NAME')

const initialState = {
  baseTitle: '',
  pageName: ''
}

export default handleActions(
  {
    [SET_BASE_TITLE]: (state, action) => ({
      ...state,
      baseTitle: action.payload
    }),
    [SET_PAGE_NAME]: (state, action) => ({
      ...state,
      pageName: action.payload
    })
  },
  initialState
)

export const setBaseTitle = country => {
  return dispatch => {
    let title = 'Hylte SIM'
    document.title = title
    dispatch(SET_BASE_TITLE(title))
  }
}

export const setPageName = name => {
  return (dispatch, getState) => {
    let baseTitle = getState().page.baseTitle
    let title = baseTitle.concat(' - ').concat(name)
    document.title = title
    dispatch(SET_PAGE_NAME(name))
  }
}



// WEBPACK FOOTER //
// ./src/store/page.js